import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { FeatureItem } from "./FeatureItem";
import { IInspectorFeaturesSection } from "./types";

type IProps = IInspectorFeaturesSection;

export const InspectorFeaturesSection: React.FC<IProps> = ({
  title,
  description,
  items,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <Grid
      customStyle={{
        padding: "40px 20px",
        [bp.FROM_DESKTOP]: {
          padding: "80px 20px",
        },
      }}
      wrapperStyle={{ backgroundColor: colors.WHITE }}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        })}
      >
        <Heading
          as="h3"
          customStyle={{
            fontSize: 36,
            lineHeight: "48px",
            marginBottom: 18,
            letterSpacing: "-0.02rem",
            color: colors.DARK_GREY,
            fontWeight: 700,
            textAlign: "center",
            [bp.FROM_DESKTOP]: {
              maxWidth: 870,
              fontSize: 48,
              lineHeight: "60px",
              marginBottom: 24,
            },
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            textAlign: "center",
            fontSize: 16,
            marginBottom: 64,
            lineHeight: "24px",
            color: colors.GRAY,
            [bp.FROM_TABLET]: {
              maxWidth: 630,
              marginBottom: 60,
            },
          })}
        >
          {description}
        </p>

        <div
          className={css({
            display: "grid",
            gridTemplateColumns: "1fr",
            [bp.FROM_TABLET]: {
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: 45,
            },
          })}
        >
          {items.map(
            ({ title, description, image, imageWrapperStyle = {} }) => (
              <FeatureItem
                key={`inspector_feature_item_${title.replace(" ", "_")}`}
                title={title}
                description={description}
                image={image}
                imageWrapperStyle={imageWrapperStyle}
              />
            ),
          )}
        </div>
      </div>
    </Grid>
  );
};
